export default __webpack_public_path__ + "static/media/picture-missions.5de32071.jpg";